import { Fragment, useEffect, useRef } from "react";
import { useDependencies } from "@servicetitan/react-ioc";
import { observer } from "mobx-react";
import { EHStore, EhWidgetModuleState } from "../stores/eh.store";
import { Loader, LoaderRef } from "@servicetitan/web-components";
import { EhWidgetEventType } from "../constants/event-types";

export const EhWidgetModules = observer(() => {
    const [{ widgetModules }] = useDependencies(EHStore);
    return (
        <Fragment>
            {Array.from(widgetModules.values()).map((widget) => (<EhWidgetModule key={module.id} widget={widget} />))}
        </Fragment>
    );
});

const EhWidgetModule = ({ widget }: { widget: EhWidgetModuleState }) => {
    const [{ setWidgetModuleState }] = useDependencies(EHStore);
    const { module, isOpenScheduled } = widget;
    const loaderRef = useRef<LoaderRef>(null);
    
    useEffect(() => {
        if (loaderRef.current) {
            const eventBus = loaderRef.current;
            setWidgetModuleState(module.apiScope, { eventBus });
            const handler = () => {
                if (isOpenScheduled) {
                    eventBus.emit(EhWidgetEventType.ModuleLinkClicked);
                }
                setWidgetModuleState(module.apiScope, { isLoaded: true, isOpenScheduled: false });
            };
            eventBus.on(EhWidgetEventType.ModuleLoaded, handler);
            return () => {
                eventBus.off(EhWidgetEventType.ModuleLoaded, handler);
            };
        }
    }, [loaderRef.current, isOpenScheduled]);

    return (
        <Loader
            ref={loaderRef}
            src={module.packageUrl}
            data={{
                appSettings: JSON.stringify(module.appSettings),
            }}
        />
    )
}